import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div className="min-h-screen bg-stone-white" data-testid="payment-cancel-page">
      <Navbar />

      <div className="pt-24 pb-16 flex items-center justify-center min-h-[80vh]">
        <div className="max-w-md mx-auto px-4 text-center">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          <h1 className="font-display text-3xl font-bold text-stone-900 mb-2">
            Payment Cancelled
          </h1>
          <p className="text-stone-600 mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/pricing">
              <Button className="w-full bg-emerald-deep hover:bg-emerald-deep/90 text-white rounded-full">
                View Plans
              </Button>
            </Link>
            <Link to="/dashboard">
              <Button variant="outline" className="w-full rounded-full">
                Back to Dashboard
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
